import * as Utils from 'Assets/Utils'

import ClientHttpRequest from "Api/ClientHttpRequest"
import Immutable from 'immutable'
import { createModal } from 'Modules/Modal'
import { isLoading } from 'Modules/Loading'

const initialState = Immutable.Map({})

/* Types */
export const SET_SUMMARY = 'SET_SUMMARY'


/* Reducer */
export default (state = initialState, action) => {

	switch (action.type) {
		case SET_SUMMARY:
			return new Immutable.Map(action.Obj)
		default:
			return state;
	}
};

/* Action Creators */


export const getSummary = (form) => {

	return (dispatch) => {

		dispatch(isLoading(true));

		return new ClientHttpRequest({
			service: 'api/getSummary',
			method: "POST",
			data: form,
			headers: Object.assign({"Authorization": sessionStorage.access_token, "uid": sessionStorage.uid, "n": localStorage.n})
		}).request().then(response => {
			dispatch(isLoading(false))
			response.data = Utils.ds_(response.data.reference)
			dispatch({type: SET_SUMMARY, Obj: response.data})
		}).catch(error => {
			dispatch(isLoading(false))
			dispatch(createModal(Utils.errorMessage(Utils.getMessageResponse(error.response.data))))
			throw error;
		});
	}
}

export const beginProcess = (form) => {

	return (dispatch) => {

		dispatch(isLoading(true));

		return new ClientHttpRequest({
			service: 'api/beginProcess',
			method: "POST",
			data: { ...form },
			headers: Object.assign({"Authorization": sessionStorage.access_token, "uid": sessionStorage.uid})
		}).request().then( () => {
			dispatch(isLoading(false))
		}).catch(error => {
			dispatch(isLoading(false))
			dispatch(createModal(Utils.errorMessage(Utils.getMessageResponse(error.response.data))))
			throw error;
		});
	}
}
// pendiente encriptar en mid con llave de usuario


// WEBPACK FOOTER //
// ./src/modules/Grantees/Register/Summary.js